import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    display: flex;
    gap: 64px;
    justify-content: space-between;
    background: #1f2547;
    border-radius: 0 0 12px 12px;
    padding: 16px 24px;
    color: #fff;
    font-style: normal;
    padding-right: 170px;

    ${mq.lt.xl} {
        padding-right: 24px;
    }

    ${mq.lt.lg} {
        gap: 10px;
        padding: 16px 12px;
    }

    ${mq.lt.md} {
        flex-direction: column;
        gap: 16px;
    }
`;

export const Flex = styled.div`
    display: flex;
`;

export const IconBox = styled.div`
    display: flex;
    align-items: flex-end;
    ${mq.lt.md} {
        display: none;
    }
`;

export const Title = styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 120%;
    margin-bottom: 4px;

    ${mq.lt.md} {
        padding-left: 0;
    }
`;

export const Data = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 0 0 8px;
`;
